import React from 'react';
import { MotorFlowType, MotorStepType } from 'scenes/motor/types';
import { stepOrder } from '../../helpers/progress';
import ProgressItem from './ProgressItem';
import { ProgressTrack } from './ProgressTrack';
import {
  calculatePhraseProgress,
  calculatePolicyDetailsProgress,
  isFlowCompleted,
  phraseDetector,
} from './utils';

interface MotorPostQuote {
  flow: MotorFlowType;
  step: MotorStepType;
}

export const MotorPostQuote = ({ flow, step }: MotorPostQuote) => {
  const currentlyInFlow = phraseDetector(flow, step);
  const checkFlowCompleted = isFlowCompleted(flow, step);

  return (
    <>
      <ProgressTrack width={30} progress={100} />
      <ProgressItem
        flowNumber={6}
        flowName="Customise"
        isCurrentFlow={currentlyInFlow(stepOrder.slice(19, 22), [
          MotorFlowType.CoverOptions,
        ])}
        isFlowComplete={checkFlowCompleted(
          MotorStepType.addDriverName,
          MotorFlowType.AddPolicyHolder
        )}
      />
      <ProgressTrack
        progress={
          checkFlowCompleted(
            MotorStepType.addDriverName,
            MotorFlowType.AddPolicyHolder
          )
            ? 100
            : calculatePhraseProgress(step, stepOrder.slice(19, 22))
        }
      />
      <ProgressItem
        flowNumber={7}
        flowName="Policy Details"
        isCurrentFlow={
          currentlyInFlow(stepOrder.slice(22, 45), [
            MotorFlowType.PolicyDetails,
          ]) ||
          currentlyInFlow(
            [MotorStepType.Name, MotorStepType.GenderAndDateOfBirth],
            [MotorFlowType.AddPolicyHolder]
          )
        }
        isFlowComplete={checkFlowCompleted(MotorStepType.PaymentFrequency)}
      />
      <ProgressTrack
        progress={
          checkFlowCompleted(MotorStepType.PaymentFrequency)
            ? 100
            : calculatePolicyDetailsProgress(step, flow)
        }
      />
      <ProgressItem
        flowNumber={8}
        flowName="Payment"
        isCurrentFlow={currentlyInFlow(stepOrder.slice(45, 50), [
          MotorFlowType.PaymentDetails,
        ])}
        isFlowComplete={false}
      />
    </>
  );
};
